module.exports = __webpack_public_path__ + "img/1_1-finanziario-palazzo-2.f64db354.png";